export const getInviteCredentials = (search = '', hash = '') => {
  const rawParams = `${search || ''}${hash || ''}`;
  const inviteParams = new URLSearchParams(rawParams);
  const inviteEmail = inviteParams.get('m')?.replace(/ /g, '+')?.trim() || '';
  const invitePassword =
    inviteParams.get('p')?.replace(/ /g, '+')?.trim() ||
    rawParams.slice(-6).replace(/ /g, '+').trim() ||
    '';
  const inviteFirstName = inviteParams.get('fn')?.trim() || '';
  const inviteLastName = inviteParams.get('ln')?.trim() || '';

  return {
    inviteEmail,
    invitePassword,
    inviteFirstName,
    inviteLastName,
  };
};
